/**
 * preview slider component
 */
import React from 'react';
import Slider from "react-slick";

const previewdata = [
   {
      name: "Filip Boksa",
      image: "Filip-Boksa.jpg",
      desc: "We use SalesHangry on all of our websites to increase engagement, trust and conversions.",
      logo: "bk-white.png",
      link: "https://www.bookingkoala.com/"
   }
]

class PreviewSlider extends React.Component {

   render() {
      const settings = {
         dots: true,
         infinite: true,
         arrows: false,
         speed: 500,
         autoplay: true,
         slidesToShow: 1,
         slidesToScroll: 1,
      };

      return (
         <div className="rct-preview-panel h-100">
            <div className="w-100 h-100">
               <Slider {...settings}>
                  {previewdata && previewdata.map((preview, index) => (
                     <div key={index} className="h-100">
                        <div className="rct-quotes-slides h-100"
                           style={{ backgroundImage: 'url(' + process.env.PUBLIC_URL + `/images/${preview.image})` }}
                        >
                           <div className="preview-content">
                              <p className="font-italic font-weight-bold mb-5">
                                 " {preview.desc} "
                              </p>
                              <div className="title">
                                 <p className="mb-2 fs-14 text-capitalize ">{preview.name}</p>
                                 <a href={preview.link} target=" ">
                                    <img src={process.env.PUBLIC_URL + `/images/${preview.logo}`} alt="preview-icon" height="50" />
                                 </a>

                              </div>
                           </div>
                        </div>
                     </div>
                  ))}
               </Slider>
            </div>
         </div>
      );
   }
}

export default PreviewSlider;